import { Routes, Route, Navigate } from 'react-router-dom';
import CreatorApp from './CreatorApp';
import CreatorHome from './CreatorHome';
import CreatorCollab from './CreatorCollab';
import CreatorDemand from './CreatorDemand';
import CreatorRequests from './CreatorRequests';
import CreatorProfileTab from './CreatorProfileTab';
import { CreatorStatsPage, CreatorBrandsPage, CreatorTopReelsPage } from './CreatorSubpages';

// The provider area is now the CREATOR app: a mobile shell (claim gate + bottom nav) with
// Home / Grow / Prices screens. The legacy seller portal (providers+ad_options) is retired.
export default function ProviderRoutes() {
  return (
    <Routes>
      <Route element={<CreatorApp />}>
        <Route index element={<CreatorHome />} />
        <Route path="stats" element={<CreatorStatsPage />} />
        <Route path="brands" element={<CreatorBrandsPage />} />
        <Route path="top-reels" element={<CreatorTopReelsPage />} />
        <Route path="collabs" element={<CreatorCollab />} />
        <Route path="demand" element={<CreatorDemand />} />
        <Route path="requests" element={<CreatorRequests />} />
        <Route path="prices" element={<CreatorProfileTab />} />
      </Route>
      <Route path="*" element={<Navigate to="/provider" replace />} />
    </Routes>
  );
}
